import $ from 'jquery';
import paper from 'paper';
import _ from 'lodash';

export default (container, $store) => {
  let $container = $(container);
  let canvas =  $container.find('canvas')[0];
  let $canvas = $(canvas);
  let screenRation = window.innerHeight / window.innerWidth;
  let fadeOutPoint = screenRation > 1 ? 200 : 150; // portrait vs landscape
  // console.log('fadeout pointer',fadeOutPoint);
  paper.setup(canvas);

  // global paper view object
  let paperView = paper.view;
  // let drainFactor = $document.innerHeight()*0.005;

  // container for all wave paths created;
  let paths = [];
  let queue;
  let progress = 0;

  let preloaded = false;

  function loadAssets() {
    let queue = new window.createjs.LoadQueue();
    var items = [];

    // logo animation
    for(var i=0; i<283; i++){
      var url = window.location.pathname + 'images/hero-sequence/logo';
      var num = '0' + i;
      if(i < 10) {
        num = '000' + i;
      } else if (i < 100) {
        num = '00' + i;
      }

      items.push({
        src: url + num + '.png'
      });
    }
    queue.loadManifest(items, false);

    queue.on('progress', function () {
      setTimeout(function () {
        progress = queue.progress;
      }, 300);
    });

    return queue;
  }


  function createPath(options) {
    let path = new paper.Path({
      fillColor: options.fillColor
    });
    let center = paperView.center;
    let width = paperView.size.width;

    // container for all Points
    path.segments = [];
    // bind path to bottom left of screen
    path.add(paperView.bounds.bottomLeft);

    for (let i = 0; i < options.points; i++) {
      let point = new paper.Point(width / (options.points - 1) * (i), center.y);
      path.add(point);
    }

    // bind path to bottom right of screen
    path.add(paperView.bounds.bottomRight);

    // scale to smooth overall shape off the screen edges
    path.scale(2);

    // blend if required
    // path.blendMode = options.blendMode;

    // Select the path, so we can see how it is constructed:
    // path.fullySelected = true;

    // save for later use in animation
    path.options = options;
    return path;
  }

  function animateWaves(event, path) {
    let length = path.segments.length;
    // i offsets from first and last to avoid animating the bottom left
    // and bottom right anchor points
    for (let i = 1; i < length - 1; i++) {
      let segment = path.segments[i];
      // Sin a cylic value between -1 and 1
      // first sin creates the wave form
      let sine = Math.sin(event.time * 2 + i * path.options.waveDirection);
      // cosin creates the y axis oscilation
      let cosine = Math.cos(1 / event.time * 2 + i);
      // Change the y position of the segment point, keep it in middle of the view
      segment.point.y = sine * path.options.waveHeight * cosine + paperView.center.y;
    }
    // smooth the path
    path.smooth({
      type: 'continuous'
    });
  }
  // let oldTop = $canv
  function drainWater(loadPercent) {
    $canvas.css('margin-top', loadPercent + '%');
  }

  function getWaveHeight () {
    let base = 20;
    if(window.outerWidth > 700) {
      base = 40;
    }
    if(window.outerWidth > 1200) {
      base = 60;
    }
    return base;
  }

  // initialiation routine
  function init () {
    // add loading
    $store.dispatch('preloading');
    queue = loadAssets();
    queue.load();

    // on resize we need to kill old paths and recreate
    if(paths.length) {
      paths.forEach(function (path) {
        path.remove();
        paperView.update();
      });
    }

    let waveHeight = getWaveHeight();

    // initial waves options
    let waves = [
      {
        points: 8,
        fillColor: 'rgba(221,247,251, 1)',
        waveHeight: waveHeight,//viewRatio * waveFactor, //60,
        // blendMode: 'normal',
        waveDirection: 1
      },
      {
        points: 5,
        fillColor: 'rgba(196,237,239, 0.8)',
        waveHeight: waveHeight * 2,//viewRatio * waveFactor * 2, //120,
        // blendMode: 'normal',
        waveDirection: -1
      }
    ];

    // create new paths from waves template
    waves.forEach(function (wave) {
      paths.push(createPath(wave));
    });

    // ready for showing
    //

    // this is a safety catch, if we are still here when the frame bellow
    // stops then fade out the preloader and move on
    paperView.on('frame', _.debounce(function () {
      // console.log('final frame');
      $container.fadeOut(5000);
      $store.dispatch('preloaded');
    }, 1000));
  }

  // View event methods ///////////////////////////////////////////////////////

  // triggers on canvas rsize
  paperView.on('resize', function () {
    setTimeout(function () {
      init();
    }, 100);
  });

  // triggers 60 frames per second
  paperView.onFrame = function (event) {
    window.evt = event;
    let loaded = Math.floor(progress * 20);
    let time = Math.floor(event.time * 10);
    let drainDown = time - loaded;
    // Loop through the segments of the path:
    // console.log('time:',time, ' | loaded:', loaded, ' | drain:',drainDown);
    if (paths.length) {
      paths.forEach(function (path) {
        animateWaves(event, path);
      });
      // drainWater();
      // var percetage = queue.progress;
      if(drainDown > fadeOutPoint && progress == 1 && !preloaded) {
        // drainWater(1);
        $container.fadeOut(5000);
        $store.dispatch('preloaded');
        // $('.container').addClass('ready'); // temporary, move to VUEX state management
        preloaded = true;
      } else {
        if(drainDown > 50) {
          $store.dispatch('preloadedHalf');
        }
        drainWater(drainDown);
      }
    }
  };

  /////////////////////////////////////////////////////////////////////////////

  // expose methods
  return {
    init: init
  };
};



// WEBPACK FOOTER //
// ./C:/projects/okinawa/be-okinawa/src/js/components/pre-loader/waves.js